// import './chat-list.scss';

export { default } from './ChatList';
export { default as template } from './chat-list.tpl';
